import styles from "./SubSideBar.module.css"
import { BrowserRouter, Routes, Route, Link, useNavigate } from 'react-router-dom';
import addicon from "./icon/Add.svg";

function SubSideBar({ data }) {
      // 구조분해할당으로 꺼내기
  const { btns, navigateFunc, text, selectedBtn } = data;

    const navigate= useNavigate();
    const handleToPath = (path)=>{
        navigate(path);
    }


    return (
        <div className={styles.submenuWrapper}>
            {/* 추가 아이콘 버튼 */}
            <div className={styles.addParent} onClick={navigateFunc}>
                <img src={addicon} className={styles.addIcon} alt="작성 추가아이콘" />
                <div className={styles.div}>{text}</div>
            </div>
            
            <div className={styles.tabWrapper}>
                {btns.map((btn) =>

                        <div key={btn.name} className={`${styles.tab} ${selectedBtn ===  btn.name ? styles.active : ""}`} onClick={() => handleToPath(btn.path)}>
                            {btn.name}
                        </div>
                        
            
                )}
            </div>
        </div>
    )
}

export default SubSideBar;